export default class LineupsSnippetNotFoundError extends Error {}
